import { type EntityRef } from "@client/types";
import { type LabelsAppState } from "@client/types/AppState/labels";
import { type PortableEntities } from "@client/types/Snapshot";
import { type StyleSheetData } from "@client/types/StyleSheet";
import { type ViewerInterface } from "@client/viewer/interface";
import { useUpdated } from "@common/lib/hooks";
import { toArray } from "lodash";
import React from "react";

export type BlogDetailPostProps = EntityRef & {
  labels: LabelsAppState;
  portalId: string;
  pageId: string | null;
  styleSheet: StyleSheetData;
  content: string;
};

export default ({ content, id, ...viewerProps }: BlogDetailPostProps) => {
  const ref = React.useRef(null);
  const [vi, setVi] = React.useState<ViewerInterface | null>(null);

  useUpdated(() => {
    vi && vi.updateStyleSheet(viewerProps.styleSheet);
  }, [viewerProps.styleSheet]);

  React.useEffect(() => {
    if (vi) return;

    const pe: PortableEntities = JSON.parse(content);
    setVi(
      window.Gappstack!.viewer.default(ref.current!, {
        ...viewerProps,
        entities: pe.entities,
        local: null,
        context: "viewer",
        version: pe.moduleVersion ?? pe.version
      })
    );
  }, [content, ...toArray(viewerProps)]);

  return <div ref={ref} className="post-body" />;
};
